import { render, staticRenderFns } from "./ReservationComments.vue?vue&type=template&id=b781489e"
import script from "./ReservationComments.vue?vue&type=script&lang=js"
export * from "./ReservationComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports